import CTAManager from './CTAManager';

export default CTAManager;
